module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('i', {
    staticClass: "fa fa-clock-o fa-fw"
  }), _vm._v(" Responsive Timeline\n            ")]), _vm._v(" "), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('ul', {
    staticClass: "timeline"
  }, [_c('li', [_c('div', {
    staticClass: "timeline-badge"
  }, [_c('i', {
    staticClass: "fa fa-user-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "timeline-panel"
  }, [_c('div', {
    staticClass: "timeline-heading"
  }), _vm._v(" "), _c('div', {
    staticClass: "timeline-body"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "timeline-inverted"
  }, [_c('div', {
    staticClass: "timeline-badge warning"
  }, [_c('i', {
    staticClass: "fa fa-car",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "timeline-panel"
  }, [_c('div', {
    staticClass: "timeline-heading"
  }), _vm._v(" "), _c('div', {
    staticClass: "timeline-body"
  })])])])]), _vm._v(" ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e87e3a9e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Trip/TripTimeline.vue
// module id = 175
// module chunks = 2